import { MappedClass, MappedPropertyArray, MappedPropertyClass } from '@h5s/util-object';
import { Pagination } from '../../shared/entities/pagination';
import { ResourceReference } from './resource-reference';

@MappedClass()
export class ResourceListPaginated {
  @MappedPropertyClass(() => Pagination)
  pagination: Pagination;

  @MappedPropertyArray(() => ResourceReference)
  resources: ResourceReference[] = [];
}
